import { defineComponent as _defineComponent } from 'vue'
import { ScannedContainer } from './DispatchContainers.vue';
import ScannedContainersList from "@/components/pages/Outbound/ScannedContainersList.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'DispatchConfirmationModal',
  props: {
  packageContainerItems: {
    type: Array<ScannedContainer>
  }
},
  emits: ["closeConfirmationModal", "submitAndCloseConfirmationModal"],
  setup(__props, { emit }: { emit: ({
  (e: 'closeConfirmationModal'): void;
  (e: 'submitAndCloseConfirmationModal'): void;
}), expose: any, slots: any, attrs: any }) {





function closeModal(): void {
  emit("closeConfirmationModal");
}

function submitAndCloseModal(): void {
  emit("submitAndCloseConfirmationModal");
}

return { __sfc: true,emit, closeModal, submitAndCloseModal, ScannedContainersList }
}

})